module.exports = __webpack_public_path__ + "static/media/login-new.ac3602a5.jpg";